import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Questions from "../Questions/Questions.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

export default function AdvancedTraining() {
  useSEO(seoConfig.advancedTraining);

  return (
    <section className="contacts additional">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Циклы повышения квалификации
      </h1>

      <h3 className="about-nii__title antiCorruption__title additional__title">
        ГБУ СО "УрНИИДВиИ" проводит цикл повышения квалификации по косметологии
        (сертификационный цикл) - 144 часа на базе специальности
        "Дерматовенерологии" (при наличии доказанного стажа работы по
        косметологии 10 лет и более).
      </h3>

      <p className="dissertation__text">
        Занятия и лекции проводят ведущие специалисты института: профессора,
        доктора и кандидаты медицинских наук.
      </p>
      <p className="dissertation__text">
        Циклы повышения квалификации (144 часа) с последующей выдачей
        свидетельства о повышении квалификации государственного образца.
      </p>
      <p className="dissertation__text">
        Краткосрочные циклы тематического усовершенствования (72 часа) с
        последующей выдачей свидетельства о повышении квалификации
        государственного образца.
      </p>
      <ol>
        <li>
          <p className="dissertation__text_questions_second">
            Современные методы диагностики, лечения и профилактики хронических
            дерматозов
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Детская дерматология
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Дерматоонкология и дерматоскопия
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Эпидемиология, диагностика, лечение и профилактика сифилиса и других
            ИППП
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Лабораторная диагностика инфекций, передаваемых половым путем
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Оказание высокотехнологичной медицинской помощи больным с тяжелыми
            хроническими дерматозами
          </p>
        </li>
      </ol>

      <p className="dissertation__text">
        Для оформления договоров на обучение необходимы следующие документы,
        заверенные нотариусом:
      </p>
      <ul>
        <li>
          <p className="dissertation__text_questions_second">Паспорт;</p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Диплом о высшем медицинском образовании;
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Удостоверение об окончании ординатуры, интернатуры либо диплом о
            профессиональной переподготовке по специальности
            «дерматовенерология»;
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Сертификат специалиста;
          </p>
        </li>
        <li>
          <p className="dissertation__text_questions_second">
            Копия трудовой книжки (работа врачом – дерматовенерологом),
            заверенная печатью, подписью начальника отдела кадров с указанием
            «работает по настоящее время».
          </p>
        </li>
      </ul>

      <Questions />
    </section>
  );
}
